import { render } from "./Lozenge.vue?vue&type=template&id=0f9a1cef&scoped=true&lang=html"
import script from "./Lozenge.vue?vue&type=script&lang=js"
export * from "./Lozenge.vue?vue&type=script&lang=js"

import "./Lozenge.vue?vue&type=style&index=0&id=0f9a1cef&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0f9a1cef"

export default script